import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { useAllCountryOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { PackagesFilterFormKeys } from './schemaTypes';

interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { allCountryOptions } = useAllCountryOptions();

  return (
    <Form.Fields>
      <TextSearchField<PackagesFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.InfluencerPackageFilter')}
      />

      <SelectorField<PackagesFilterFormKeys>
        name="countryIds"
        onSubmit={onSubmit}
        className="max-w-34.5"
        options={allCountryOptions}
        placeholder={t<string>('Selector.Countries')}
        multiple
      />
    </Form.Fields>
  );
};
